  const colors = {
  normal: "#A0A29F",
  fighting: "#D3425F",
  flying: "#A1BBEC",
  poison: "#B763CF",
  ground: "#DA7C4D",
  rock: "#C9BB8A",
  bug: "#9FA244",
  ghost: "#5F6DBC",
  steel: "#5695A3",
  fire: "#FBA54C",
  water: "#539DDF",
  grass: "#5FBD58",
  electric: "#F2D94E",
  psychic: "#FA8581",
  ice: "#75D0C1",
  dragon: "#0C69C8",
  dark: "#595761",
  fairy: "#EE90E6",
  unknown: "#d5ec6d",
  shadow: "#4b4f71",
};

export default colors;